import useUser from "~/composables/useUser";
import { useAuthStore } from "@/stores/auth";
import { useEventStore } from "@/stores/event";
import _ from "lodash";
import dayjs from "dayjs";
import {
  collection,
  deleteField,
  getDocs,
  query,
  runTransaction,
  setDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/services/firebase/Instance";
import { defineStore } from "pinia";
import { endpointSetUserRichmenu } from "../services/api/enpoints";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null,
    users: [],
    phoneNumber: "",
  }),
  getters: {
    role(state) {
      if(state.user?.invite === true || state.user?.inviteMode) {
        return state.user?.inviteMode || 'viewer'
      }

      return 'owner'
    },
    displayUserList(state) {
      const eventStore = useEventStore();
      const authStore = useAuthStore();
      const list = this.users || [];
      let filteredOnlyUsers = _.filter(list, (u) => u?.admin !== true);

      if (eventStore?.isRealOwner) {
        filteredOnlyUsers = _.concat(authStore?.user, filteredOnlyUsers);
      }

      filteredOnlyUsers = _.uniqBy(filteredOnlyUsers, (u) => u?.uid);
      return filteredOnlyUsers;
    },
  },
  actions: {
    async getUserById(lineId: string) {
      const userRef = doc(db, "users", lineId);
      const userSnap = await getDoc(userRef);
      this.user = userSnap.exists() ? userSnap.data() : null;
      return this.user
    },

    async updateUserEvent(userId: string, payload: any): Promise<void> {
      return await useUser().updateUserEvent(userId, payload);
    },

    async setInviteUser({ eventId, inviteMode = "viewer", lineProfile }) {
      const appStateStore = useAppStateStore();
      const eventStore = useEventStore();

      if (!eventId) {
        alert("Event Query not found");
        return;
      }

      const isAlreadyEvent = await eventStore.checkEventAlready(eventId);
      if (!isAlreadyEvent) {
        alert("Event not found");
        appStateStore.setShowMainModal(true);
        // navigateTo("/register");
        return;
      }

      //check if user is already
      const user = await this.getUserById(lineProfile.userId);
      const targetMode = inviteMode;

      const newUserPayload = {
        displayName: lineProfile.displayName,
        firstName: lineProfile.displayName,
        lastName: "",
        phoneNumber: "",
        admin: false,
        photowishTeam: false,
        email: "",
        line: lineProfile,
        uid: lineProfile.userId,
        eventId: eventId,
        eventList: [eventId],
        photoURL: lineProfile?.pictureUrl || "",
      };

      let userPayload = {};

      if (user) {
        let eventList = [...user.eventList];
        eventList.push(eventId);
        eventList = _.uniq(eventList);

        userPayload = {
          ...user,
          invite: true,
          inviteMode: targetMode || "viewer",
          eventId: eventId,
          eventList: eventList,
        };
      } else {
        userPayload = {
          ...newUserPayload,
          invite: true,
          inviteMode: targetMode || "viewer",
        };
      }

      await this.setNewUser(lineProfile.userId, userPayload);

      return userPayload;
    },
    async getUsersTeam() {
      const eventStore = useEventStore();
      const eventId = eventStore?.eventId;

      if (!eventId) {
        return;
      }

      console.log("eventId --->", eventId);

      const q = query(collection(db, "users"), where("eventId", "==", eventId));

      const querySnapshot = await getDocs(q);
      const _users = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      this.users = _users.filter((u) => u.admin !== true);
      // this.users = _users 
      return true;
    },
    async deleteUserAccount(userId: string) {
      return await useUser().deleteUser(userId);
    },

    async syncLineProfile() {
      const authStore = useAuthStore();
      let lineProfile = authStore.line;
      let lineId = authStore.line.userId;

      if (lineProfile) {
        if (!lineProfile || !lineId) return;

        await runTransaction(db, async (transaction) => {
          const userRef = doc(db, "users", lineId);
          const userSnap = await transaction.get(userRef);
          if (userSnap.exists() && userSnap.data().eventId) {
            transaction.update(userRef, {
              line: lineProfile,
            });
          }
          return true;
        });
      }
    },

    async createNewUser() {
      const authStore = useAuthStore();

      const { eventId, mobile } = await authStore.getPreRegisterData();
      const { email, firstName, lastName } =
        authStore.pre_register?.register || {};
      const lineId = authStore.line.userId;
      // create user
      const userRef = doc(db, "users", lineId);
      await runTransaction(db, async (transaction) => {
        const userDoc = await transaction.get(userRef);
        if (userDoc.exists()) {
          transaction.update(userRef, { eventId });
          return;
        }
        const userDefault = {
          mobile,
          uid: lineId,
          eventId,
          email,
          firstName,
          lastName,
          line: authStore.line,
          admin: false,
        };
        transaction.set(userRef, userDefault);
      });

      // merge event with user
      const eventRef = doc(db, "events", eventId);
      await runTransaction(db, async (transaction) => {
        const eventDoc = await transaction.get(eventRef);

        transaction.update(eventRef, {
          notify: {
            line: {
              ...eventDoc.data()?.notify?.line,
              [lineId]: true,
            },
          },
          user: {
            ...eventDoc.data()?.user,
            [lineId]: true,
          },
        });
      });

      return eventId;
    },

    async joinEvent( ) {
      debugger
      const authStore = useAuthStore();

      const { eventId, mobile  , inviteMode , } = await authStore.getPreRegisterData();
      const { email, firstName, lastName } =
        authStore.pre_register?.register || {};


      const lineId = authStore.line.userId;
      const userRef = doc(db, "users", lineId);
      const eventRef = doc(db, "events", eventId);

      const batch = writeBatch(db);
      batch.update(eventRef, {
        [`notify.line.${lineId}`] : true ,
        [`user.${lineId}`] : true
      });
      const userDefault = {
        mobile,
        uid: lineId,
        eventId,
        email,
        firstName,
        lastName,
        inviteMode : inviteMode || "viewer",
        invite : true,
        line: authStore.line,
        admin: false,
      };
      batch.set(userRef, userDefault);

      await batch.commit();
    },

    async leaveEvent( ) {
      // - delete pre_register
      // - delete user
      // - delete event notify line

      const authStore = useAuthStore();
      const userStore = useUserStore();
      const eventStore  = useEventStore();
      const eventId= userStore.user?.eventId;
      const lineId = authStore.line.userId;
      const userRef = doc(db, "users", lineId);
      const eventRef = doc(db, "events", eventId);
      const preRegisterRef = doc(db, "pre_register", authStore.mobile || "00");

      const batch = writeBatch(db);
      batch.delete(userRef);
      batch.delete(preRegisterRef);
      batch.update(eventRef, {
        notify: {
          line: {
            ...eventStore.event?.notify?.line,
            [lineId]: false,
          },
        },
        user : {
          ...eventStore.event?.user,
          [lineId]: false,
        }
      });

      await batch.commit();
    },

    async updateUserInviteMode(userId: string, mode: string) {
      console.log(userId)
      console.log(mode)

      await useUser().setMergeUser(userId, {
        inviteMode: mode
      })
    },

    async changeRichMenu(userId: string, eventPackage:string) {
      let richMenuId = 'richmenu-0ffe95a8758a1cd3e6ce832b6afc7b49'

      if(eventPackage  !== 'free') {
        richMenuId = 'richmenu-a3c12ce425e35d5c476d4f92a400bc72' // paid
      }

      if(!userId || !richMenuId) {
        return;
      }

      const api = endpointSetUserRichmenu.cloud;
      await fetch(api, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          type: "link_user",
          userId,
          richMenuId
        }),
      });
    },

    async devUserUpdateEventId (type = 'set', targetEventId: string) {
      if(!this.user?.uid || !targetEventId) {
        return  alert('missing uid or target eventId')
      }

      try {
        const eventStore = useEventStore()
        const userRef = doc(db, 'users', this.user?.uid)
        return  setDoc(userRef, {
          eventId: targetEventId,
          originalEventId: type === 'set' ? eventStore?.eventId : deleteField()
        }, { merge: true })
      } catch (error: any) {
        alert('something wrong: ', error)
        return null
      }
    },
  },
});
